import { styled } from 'stitches.config'

export const OurIngredientsRoot = styled('div', {
  width: '100%',
  overflow: 'hidden',
})

export const OurIngredientsSection = styled('div', {
  padding: '$2',
  maxWidth: '1500px',
  margin: 'auto',
  display: 'flex',
  flexDirection: 'column',

  '@bp3': {
    flexDirection: 'row',
    padding: '$8',
    paddingBottom: '$4',
  },
})

export const BenefitsWrapper = styled('div', {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '$3',
  marginTop: '$4',

  '@bp3': {
    width: '50%',
    gap: 0,
    marginTop: 0,
  },
})

export const IngredientsWrapper = styled('div', {
  display: 'block',
  width: '100%',
  marginTop: '$5',
  marginBottom: '$4',

  '@bp3': {
    width: '50%',
    margin: '0',
  },
})

export const BenefitsList = styled('div', {
  color: '$accent-black',
  display: 'none',
  '@bp3': {
    display: 'block',
  },

  '& > ul > li': {
    marginBottom: '$3',
  },

  '& ul': {
    listStyleType: 'disc',
    paddingLeft: '$2',
    margin: '$2 0',

    '& li': {
      marginBottom: '0.5rem',
      fontSize: '$bodyExtraLarge',
      color: '$accent-black',

      '&:before': {
        content: '"•"',
        color: '$accent-black',
        display: 'inline-block',
        width: '1.5rem',
        marginLeft: '-$1',
      },
    },
  },
})

export const MobileList = styled('div', {
  lineHeight: '$headline',
  display: 'block',

  textAlign: 'center',
  margin: 'auto',
  maxWidth: '200px',

  marginTop: '8px',
  fontSize: '$headline',
  color: '$accent-black',

  '@bp3': {
    display: 'none',
  },
})

export const InfoWrapper = styled('div', {
  display: 'none',
  '@bp3': {
    display: 'block',
  },

  '& > div': {
    marginLeft: 0,
    maxWidth: '500px',
    '@bp3': {
      marginTop: '32px',
    },
  },
})

export const SliderContainer = styled('div', {
  display: 'block',
  maxWidth: '300px',
  margin: 'auto',
  marginTop: '$2',

  '& .slick-next': {
    height: 0,
    width: 0,
  },

  '& .slick-prev': {
    height: 0,
    width: 0,
  },

  '& .slick-list': {
    zIndex: 1,
  },

  '& .slick-dots': {
    bottom: '-28px',
    zIndex: 2,
  },

  '& .slick-dots li button:before': {
    fontSize: '12px',
    color: '$accent-white',
    opacity: 1,
  },

  '& .slick-dots li.slick-active button:before': {
    color: '$primary-500',
    opacity: 1,
  },

  '@bp3': {
    marginTop: '$5',
    width: '500px',

    '& .slick-next': {
      height: '50px',
      width: '50px',
      right: '-60px',
    },

    '& .slick-prev': {
      height: '50px',
      width: '50px',
      left: '-60px',
    },

    '& .slick-dots li button:before': {
      display: 'none',
    },
  },
})

export const SectionTitle = styled('h2', {
  fontSize: '$h2',
  color: '$primary-500',
  fontWeight: '$semiBold',
  width: '100%',
  textAlign: 'center',
  margin: 'auto',
  '@bp3': {
    fontSize: '$h1',
    textAlign: 'left',
  },

  variants: {
    center: {
      true: {
        '@bp3': { textAlign: 'center' },
      },
    },
  },
})

export const IngredientsCard = styled('div', {
  width: '100%',
})

export const CardImage = styled('div', {
  width: '160px',
  margin: 'auto',
})

export const CardText = styled('div', {
  width: '235px',
  margin: 'auto',
  textAlign: 'center',
})

export const BorderWrapper = styled('div', {
  background: '$tertiary-200',
  position: 'relative',
  top: '-1px',

  variants: {
    recipe: {
      beef: { background: '$accent-white', top: '-1px' },
      lamb: { background: '$tertiary-200', top: '1px' },
      turkey: { display: 'none' },
    },
  },
})
